/*LIBRARY*/
import { connect } from "react-redux";
import { Link } from "react-router-dom";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/
import official_account from "../../Assets/svg/official_account.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";

/*CONST*/

const BlogListPublic = ({ blog_list, blog }) => {
  const language = localStorage?.language ? localStorage?.language : "ina";
  const { loadingProcess, itemLoading, blog_list_popular } = blog;

  // Style for 3-line clamping
  const lineClampStyle = {
    display: "-webkit-box",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  // Style for 1-line clamping
  const singleLineStyle = {
    display: "-webkit-box",
    WebkitLineClamp: 1,
    WebkitBoxOrient: "vertical",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  let itemContent;
  if (
    loadingProcess &&
    itemLoading === "get_list_data_exchange" &&
    blog_list.length === 0
  ) {
    itemContent = <div>{dict["Loading publication"][language]} ...</div>;
  } else {
    itemContent = (
      <main
        style={{
          display: "inline-block",
          verticalAlign: "top",
        }}
      >
        {blog_list_popular.map((blog_item) => {
          const { _id, title, title_en, link, authors } = blog_item;
          const picture_url = blog_item?.picture_url
            ? blog_item?.picture_url
            : "";
          const full_name = authors[0]?.user?.full_name;
          const badge = authors[0]?.user?.badge;
          const is_official = badge === "official";
          const url_img = String(picture_url).replace(/\s/g, "%20");

          return (
            <Link to={`/blog_read/${link}`} key={_id}>
              <section className="container_blog_card" id="white">
                <main className="container_square">
                  <section
                    className="container_image_blog"
                    style={{
                      backgroundImage: `url(${url_img})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  />
                  <section style={{ position: "absolute", top: 0, right: 0 }}>
                    <svg
                      style={{
                        width: "3rem",
                        height: "auto",
                        borderTopRightRadius: "5px",
                      }}
                      viewBox="0 0 135 171"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M135 0H0V171H20.2235L67.5 134L114.776 171H135V0Z"
                        fill="#1E3A8A"
                      ></path>
                      <path
                        d="M37.0781 41L40.6577 19.1818H44.0668L40.4872 41H37.0781ZM27.3089 35.5881L27.8736 32.179H44.919L44.3544 35.5881H27.3089ZM29.4077 41L32.9872 19.1818H36.3963L32.8168 41H29.4077ZM28.5554 28.0028L29.1307 24.5938H46.1761L45.6009 28.0028H28.5554ZM57.7431 19.1818V41H53.1301V23.5604H53.0023L48.0059 26.6925V22.6016L53.4071 19.1818H57.7431ZM28.0653 58.9851V55.1818H45.9844V58.9851H39.3047V77H34.745V58.9851H28.0653ZM48.9354 77V55.1818H53.5483V64.1839H62.9126V55.1818H67.5149V77H62.9126V67.9872H53.5483V77H48.9354ZM75.9311 55.1818V77H71.3182V55.1818H75.9311ZM91.5623 61.4567C91.4771 60.5973 91.1113 59.9297 90.465 59.4538C89.8187 58.978 88.9416 58.7401 87.8336 58.7401C87.0808 58.7401 86.4451 58.8466 85.9267 59.0597C85.4082 59.2656 85.0105 59.5533 84.7335 59.9226C84.4636 60.2919 84.3287 60.7109 84.3287 61.1797C84.3145 61.5703 84.3961 61.9112 84.5737 62.2024C84.7583 62.4936 85.0105 62.7457 85.3301 62.9588C85.6497 63.1648 86.019 63.3459 86.438 63.5021C86.8571 63.6513 87.3045 63.7791 87.7804 63.8857L89.7406 64.3544C90.6923 64.5675 91.5659 64.8516 92.3613 65.2067C93.1568 65.5618 93.8457 65.9986 94.4281 66.517C95.0105 67.0355 95.4615 67.6463 95.7811 68.3494C96.1078 69.0526 96.2747 69.8587 96.2818 70.7678C96.2747 72.103 95.9338 73.2607 95.2591 74.2408C94.5914 75.2138 93.6255 75.9702 92.3613 76.5099C91.1042 77.0426 89.5879 77.3089 87.8123 77.3089C86.051 77.3089 84.5169 77.0391 83.21 76.4993C81.9103 75.9595 80.8947 75.1605 80.1632 74.1023C79.4387 73.0369 79.0588 71.7195 79.0233 70.1499H83.487C83.5368 70.8814 83.7463 71.4922 84.1156 71.9822C84.492 72.4652 84.9927 72.831 85.6177 73.0795C86.2498 73.321 86.9636 73.4418 87.7591 73.4418C88.5403 73.4418 89.2186 73.3281 89.7939 73.1009C90.3762 72.8736 90.8272 72.5575 91.1468 72.1527C91.4664 71.7479 91.6262 71.2827 91.6262 70.7571C91.6262 70.267 91.4806 69.8551 91.1895 69.5213C90.9054 69.1875 90.4863 68.9034 89.9324 68.669C89.3855 68.4347 88.7143 68.2216 87.9189 68.0298L85.5431 67.4332C83.7037 66.9858 82.2512 66.2862 81.1859 65.3345C80.1206 64.3828 79.5914 63.1009 79.5985 61.4886C79.5914 60.1676 79.943 59.0135 80.6532 58.0263C81.3706 57.0391 82.3542 56.2685 83.6042 55.7145C84.8542 55.1605 86.2747 54.8835 87.8656 54.8835C89.4849 54.8835 90.8983 55.1605 92.1056 55.7145C93.3201 56.2685 94.2647 57.0391 94.9395 58.0263C95.6142 59.0135 95.9622 60.157 95.9835 61.4567H91.5623ZM33.8075 113L27.5646 91.1818H32.6037L36.2152 106.342H36.3963L40.3807 91.1818H44.6953L48.669 106.374H48.8608L52.4723 91.1818H57.5114L51.2685 113H46.7727L42.6179 98.7351H42.4474L38.3033 113H33.8075ZM59.9803 113V91.1818H74.682V94.9851H64.5932V100.184H73.9256V103.987H64.5932V109.197H74.7246V113H59.9803ZM78.3494 113V91.1818H93.0511V94.9851H82.9624V100.184H92.2947V103.987H82.9624V109.197H93.0938V113H78.3494ZM96.7186 113V91.1818H101.331V100.802H101.619L109.471 91.1818H115L106.903 100.951L115.096 113H109.577L103.601 104.03L101.331 106.8V113H96.7186Z"
                        fill="white"
                      ></path>
                    </svg>
                  </section>
                  <section className="container_second_half_blog">
                    <h1 className="text_bold margin_top" style={lineClampStyle}>
                      {language === "ina" ? title : title_en || title}
                    </h1>
                    <p
                      className="sub_title_blog_card text_medium sub_color"
                      style={singleLineStyle}
                    >
                      {full_name}
                      {is_official && (
                        <img
                          alt="Official account"
                          src={official_account}
                          width="13px"
                          style={{ marginLeft: "5px" }}
                        />
                      )}{" "}
                    </p>
                  </section>
                </main>
              </section>
            </Link>
          );
        })}
        {blog_list.map((blog_item) => {
          const { _id, title, title_en, link, authors } = blog_item;
          const picture_url = blog_item?.picture_url
            ? blog_item?.picture_url
            : "";
          const full_name = authors[0]?.user?.full_name;
          const badge = authors[0]?.user?.badge;
          const is_official = badge === "official";
          const url_img = String(picture_url).replace(/\s/g, "%20");
          let text_status = dict["Public"][language];
          const market_status = blog_item?.market_status;
          if (market_status?.status === "free") {
            text_status = dict["Free"][language];
          } else if (market_status?.status === "paid") {
            text_status = `Rp ${new Intl.NumberFormat("id-ID", {
              style: "decimal",
            }).format(1.1 * 1.3 * market_status?.price)}`;
          }
          return (
            <Link to={`/blog_read/${link}`} key={_id}>
              <section className="container_blog_card" id="white">
                <main className="container_square">
                  <section
                    className="container_image_blog"
                    style={{
                      backgroundImage: `url(${url_img})`,
                      backgroundPosition: "center",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "cover",
                    }}
                  />
                  <section className="container_badge">{text_status}</section>
                  <section className="container_second_half_blog">
                    <h1 className="text_bold margin_top" style={lineClampStyle}>
                      {language === "ina" ? title : title_en || title}
                    </h1>
                    <p
                      className="sub_title_blog_card text_medium sub_color"
                      style={singleLineStyle}
                      title={
                        full_name ||
                        dict?.["The author did not provide his full name"]?.[
                          language
                        ]
                      }
                    >
                      {full_name || dict?.["Author"]?.[language]}
                      {is_official && (
                        <img
                          alt="Official account"
                          src={official_account}
                          width="13px"
                          style={{ marginLeft: "5px" }}
                        />
                      )}{" "}
                    </p>
                  </section>
                </main>
              </section>
            </Link>
          );
        })}
      </main>
    );
  }
  return (
    <main>
      <div style={{ marginBottom: "30px", textAlign: "center" }}>
        <h1 className="text_big margin_bottom">
          {dict?.["Publication"]?.[language]}
        </h1>
        {itemContent}
      </div>
    </main>
  );
};

const mapStateToProps = (state) => ({
  blog: state.blog,
});

export default connect(mapStateToProps)(BlogListPublic);
